(function () {
  'use strict';

  /* Touch devices only — desktop never initializes. No mouse/pointer handling. */
  if (!('ontouchstart' in window)) return;

  var content = document.querySelector('[data-ptr-content]');
  var spinner = document.querySelector('.ptr-spinner');
  var pill = document.querySelector('[data-ptr-pill]');
  var logo = document.querySelector('.ptr-logo');
  if (!content || !spinner) return;

  var ticks = Array.prototype.slice.call(spinner.querySelectorAll('.ptr-tick'));
  var TICK_COUNT = 12;

  var MAX_PULL = 150;
  var REFRESH_THRESHOLD = 90; /* reachable with ~95px of finger travel */
  var LOCK_POSITION = 130; /* clears the full logo (bottom ~122px) with margin */
  var REFRESH_DURATION = 650; /* spinner spin time before the reload */
  var RESISTANCE = 1.7; /* finger travel to reach full pull = MAX_PULL * RESISTANCE */

  var SCALE_START = 0.7; /* logo only grows in the last 30% of the pull */

  var startY = 0;
  var pulling = false;        /* an eligible gesture is in progress */
  var dragging = false;       /* finger has actually moved us past 0 */
  var refreshing = false;
  var currentPull = 0;
  var rafId = null;

  function scrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function setLitTicks(progress) {
    var active = Math.floor(progress * TICK_COUNT);
    for (var i = 0; i < ticks.length; i++) {
      ticks[i].classList.toggle('is-lit', i < active);
      ticks[i].classList.toggle('is-newest', i === active - 1);
    }
  }

  function render() {
    rafId = null;
    if (refreshing) return; /* don't fight the settle/fade animation */
    var progress = currentPull / MAX_PULL;
    if (progress > 1) progress = 1;

    content.style.transform = 'translateY(' + currentPull + 'px)';
    content.style.setProperty('--ptr-progress', progress.toFixed(3));
    if (pill) pill.style.setProperty('--ptr-progress', progress.toFixed(3));

    setLitTicks(progress);

    var scaleProgress = Math.max(0, (progress - SCALE_START) / (1 - SCALE_START));
    var scale = 0.88 + scaleProgress * 0.12;
    if (logo) logo.style.setProperty('--ptr-logo-scale', scale.toFixed(3));
  }

  function scheduleRender() {
    if (rafId === null) rafId = window.requestAnimationFrame(render);
  }

  function beginPulseState() {
    content.classList.add('is-pulling');
    if (logo) logo.classList.add('is-pulling');
  }

  /* Animate content back to its natural position (no transform) and reset visuals. */
  function reset() {
    content.classList.add('is-animating');
    content.classList.remove('is-pulling');
    content.style.transform = '';
    content.style.setProperty('--ptr-progress', '0');
    if (pill) pill.style.setProperty('--ptr-progress', '0');
    if (logo) {
      logo.classList.remove('is-pulling');
      logo.style.setProperty('--ptr-logo-scale', '0.88');
    }

    function done() {
      content.classList.remove('is-animating');
      content.style.willChange = '';
      content.removeEventListener('transitionend', done);
    }
    content.addEventListener('transitionend', done);
    /* Fallback in case transitionend doesn't fire (must exceed the 0.45s transition) */
    window.setTimeout(done, 550);

    currentPull = 0;
    pulling = false;
    dragging = false;
  }

  function triggerRefresh() {
    refreshing = true;

    /* 1) Buttery settle into the lock position; logo eases up to full size. */
    content.classList.add('is-animating');
    content.style.transform = 'translateY(' + LOCK_POSITION + 'px)';
    if (pill) pill.style.setProperty('--ptr-progress', '1');
    if (logo) {
      logo.classList.remove('is-pulling'); /* re-enable the scale transition */
      logo.style.setProperty('--ptr-logo-scale', '1');
    }
    spinner.classList.add('is-refreshing');

    /* 2) Hold the spin briefly, then REALLY reload. */
    window.setTimeout(function () {
      window.location.reload();
    }, REFRESH_DURATION);
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      if (refreshing) return;
      if (scrollTop() > 0) return;
      if (e.touches.length !== 1) return;
      startY = e.touches[0].clientY;
      pulling = true;
      dragging = false;
      content.classList.remove('is-animating');
      content.style.willChange = 'transform';
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!pulling || refreshing) return;

      var raw = e.touches[0].clientY - startY;

      /* If the user is scrolling up or we've scrolled away from the top, bail. */
      if (raw <= 0 || scrollTop() > 0) {
        if (dragging) {
          reset(false);
        } else {
          pulling = false;
          content.style.willChange = '';
        }
        return;
      }

      /* Active downward pull from the top — suppress native overscroll. */
      if (e.cancelable) e.preventDefault();

      if (!dragging) {
        dragging = true;
        beginPulseState();
      }

      /* Smooth diminishing resistance. Gain starts at exactly 1 (content tracks
         the finger 1:1) and eases continuously to 0 as it approaches MAX_PULL —
         no initial gain spike, so there is no "snap". */
      var u = Math.min(raw / (MAX_PULL * RESISTANCE), 1);
      currentPull = (2 * u - u * u) * MAX_PULL;
      scheduleRender();
    },
    { passive: false }
  );

  document.addEventListener(
    'touchend',
    function () {
      if (!pulling || refreshing) return;
      pulling = false;

      if (dragging && currentPull >= REFRESH_THRESHOLD) {
        triggerRefresh();
      } else if (dragging) {
        reset(false);
      } else {
        content.style.willChange = '';
      }
    },
    { passive: true }
  );
})();
